import { Box, Modal, Paragraph, TextButton } from '@zillow/constellation-10';

import { EXTERNAL_URLS } from '../../../constants/urls';

import ZillowInsuranceServicesLogo from '../../RentalProtection/shared/ZillowInsuranceServicesLogo';

import ModalFooter from '../ModalFooter';
import ExpandableDisclaimerWithData from './ExpandableDisclaimerWithData';
import RentGuaranteeSelectionsContent from './RentGuaranteeSelectionsContent';

const RentalProtectionSelectionsModal = ({
  onClose,
  premium,
  monthlyRent,
  isSecurityDepositWaived,
  securityDepositAmount,
}: {
  onClose: () => void;
  premium: number;
  monthlyRent: number;
  isSecurityDepositWaived: boolean;
  securityDepositAmount: number;
}) => {
  const landlordReceiptAmount = monthlyRent - premium;

  return (
    <Modal
      open={true}
      onOpenChange={(open) => !open && onClose()}
      header={<ZillowInsuranceServicesLogo />}
      footer={<ModalFooter submitText="OK" onSubmit={onClose} />}
      size={{ base: 'fullScreen', md: 'md' }}
      body={
        <Box css={{ padding: { base: '200', md: '600' } }} data-testid="RentalProtectionSelectionsModal">
          <div data-testid="HeaderContainer">
            <Paragraph css={{ textStyle: 'heading-sm', marginBottom: '400' }}>
              Your Rental Protection selections
            </Paragraph>
            <Paragraph>
              You started a request for Rental Protection. For more information about details and coverage,{' '}
              <TextButton asChild>
                <a href={EXTERNAL_URLS.RENTAL_PROTECTION_DETAILS_COVERAGE} target="_blank" rel="noopener noreferrer">
                  Select
                </a>
              </TextButton>
              .
            </Paragraph>
          </div>
          <div data-testid="SelectionsContainer">
            <RentGuaranteeSelectionsContent
              premium={premium}
              monthlyRent={monthlyRent}
              landlordReceiptAmount={landlordReceiptAmount}
              isSecurityDepositWaived={isSecurityDepositWaived}
              securityDepositAmount={securityDepositAmount}
            />
          </div>
          <ExpandableDisclaimerWithData displaySurplusTaxesAndFees={true} />
        </Box>
      }
    />
  );
};

export default RentalProtectionSelectionsModal;
